export default {
	filters: {
		date: function (date) {
			if (date === null) {
				return null;
			}
			return moment(date).format('DD/MM/YYYY')
		},
	}
};
